/**
 * 应用配置文件
 * 统一管理前端和后端地址配置
 */

// 开发环境配置
const developmentConfig = {
  // 前端开发服务器地址
  FRONTEND_URL: 'http://localhost:8080',
  // 后端服务器地址 (不包含/api路径)
  API_BASE_URL: 'http://localhost:5001'
};

// 生产环境配置
const productionConfig = {
  // 生产环境下前端和后端通常在同一域名
  FRONTEND_URL: window.location.origin,
  // 后端服务器地址 (不包含/api路径)
  API_BASE_URL: window.location.origin
};

// 根据环境选择配置
const getConfig = () => {
  // 优先使用环境变量
//   if (process.env.VUE_APP_API_URL) {
//     return {
//       FRONTEND_URL: process.env.VUE_APP_FRONTEND_URL || window.location.origin,
//       API_BASE_URL: process.env.VUE_APP_API_URL
//     };
//   }

  // 根据NODE_ENV选择配置
  return process.env.NODE_ENV === 'development' ? developmentConfig : productionConfig;
};

// 导出配置对象
export const config = getConfig();

// 便捷方法
export const getApiUrl = () => `${config.API_BASE_URL}`;
export const getFrontendUrl = () => config.FRONTEND_URL;
export const getBackendUrl = () => config.API_BASE_URL;

// 构建完整的API端点URL
export const buildApiUrl = (endpoint) => {
  const apiBaseUrl = getApiUrl();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${apiBaseUrl}/${cleanEndpoint}`;
};

// 构建文件URL的便捷方法
export const buildFileUrl = (fileUniqueId, isPreview = false) => {
  const url = buildApiUrl(`/api/files/${fileUniqueId}`);
  return isPreview ? `${url}?preview=true` : url;
};

// 调试信息（仅开发环境）
if (process.env.NODE_ENV === 'development') {
  console.log('App Configuration:', config);
}

export default config;
